import urlUtil from '../../util/url/urlUtil';

const urlService = {
    getDebugDevUrlKey(): string {
        const appName = APP_NAME;
        return `${appName}_GRADING_DEBUG_DEV_URL`;
    },

    getLocationForDevEnvironment(): string {
        const gradingUrl: string = sessionStorage.getItem(urlService.getDebugDevUrlKey());
        if (gradingUrl) {
            return urlUtil.getRootUrlFromLocation(new URL(gradingUrl));
        }

        return CONFIG.devRoot;
    },

    prependDomain(path: string): string {
        if (process.env.NODE_ENV === 'development' && DEV_PICK_ENV) {
            return `${urlService.getLocationForDevEnvironment()}${path}`;
        }
        return urlUtil.prependCurrentProtocolHostAndPort(path);
    },
};

export default urlService;
